import { PosicaoClientesActionsTypes } from "./posicaoClientesActions"
import type { PosicaoClientesAction } from "./posicaoClientesActions"
import type { PosicaoClientesModel } from "../models/posicaoClientesModel"

export function posicaoClientesReducer(
    state: PosicaoClientesModel,
    action: PosicaoClientesAction
): PosicaoClientesModel {
    switch (action.type) {
        case PosicaoClientesActionsTypes.CARREGAR:
            return { ...state, clientes: action.payload, sortudo: null }

        case PosicaoClientesActionsTypes.ATUALIZAR_FILTRO:
            return {
                ...state,
                filtro: { ...state.filtro, [action.payload.campo]: action.payload.valor },
            }

        case PosicaoClientesActionsTypes.SORTEAR: {
            if (state.clientes.length === 0) return state
            const idx = Math.floor(Math.random() * state.clientes.length)
            return { ...state, sortudo: state.clientes[idx] }
        }

        default:
            return state
    }
}
